<div *transloco="let t; read: 'inline-confirmation'" class="inline-confirmation">
  <accredible-icon icon="warning" />

  <div class="font-s-semibold confirmation-text" [innerHTML]="confirmationText()"></div>

  <div class="actions">
    <button
      accredible-button-outline
      class="btn-confirm"
      size="small"
      color="danger"
      [attr.data-cy]="confirmDataCy()"
      (click)="confirm.emit($event)">
      {{ confirmButtonText() }}
    </button>

    <button
      accredible-button-outline
      class="btn-cancel"
      size="small"
      color="primary"
      [attr.data-cy]="cancelDataCy()"
      (click)="cancel.emit($event)">
      {{ cancelButtonText() }}
    </button>
  </div>
</div>
